import { createRedesignEntry } from "../redesign-page-entry";

export default createRedesignEntry(() => import("./expert-consultation-page"), {
  testId: "rd-ec-loading",
  shell: { activeNav: "consultations" },
});
